module.exports = __webpack_public_path__ + "img/postgresql.e1e07213.svg";